import React from "react";
import Icon from "../../assets/icons/Icon";
import injectSheet from "react-jss";
import SingleSelect2 from "../../components/select/SingleSelect2";
import BeautifulSpinner from "../../components/Loaders/BeautifulSpinner";
import classNames from "classnames";

class SearchArrangemangContainer extends React.Component {
  render() {
    const {
      classes,
      className,
      isSearching,
      searchResult,
      searchValue,
      handleSearchChange,
      handleReset,
      handleClick,
      customButton,
      handleClosePopup,
      customSearchItem,
      placeHolder = "Sök via nr eller namn",
      dataCy = "searchfield-input",
    } = this.props;

    return (
      <div className={classNames(classes.searcharea, className)}>
        <div className={classes.searchIcon}>
          {isSearching ? (
            <BeautifulSpinner width="25" height="25" />
          ) : (
            <Icon type="magnify" width="16px" fill="gray" />
          )}
        </div>
        <div className={classes.searchBar}>
          <input
            type="text"
            placeholder={placeHolder}
            value={searchValue}
            data-cy={dataCy}
            onKeyDown={(e) => {
              if (e.key === "ArrowDown") {
                if (this.select) {
                  e.preventDefault();
                  this.select.focus();
                }
              }
              if (e.key === "Enter") e.preventDefault();
              if (e.key === "Escape") handleReset();
            }}
            onChange={(e) => handleSearchChange(e)}
          />
          <SingleSelect2
            onRef={(ref) => (this.select = ref)}
            handleValueNameChange={handleClick}
            top="0"
            handleEscape={handleReset}
            width="100%"
            name="search"
            elements={searchResult}
            customButton={customButton}
            customSearchItem={customSearchItem}
            handleClosePopup={handleClosePopup}
          >
            <span></span>
          </SingleSelect2>
        </div>
      </div>
    );
  }
}

const styles = {
  searcharea: {
    marginBottom: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    //marginRight: "24px",
    position: "relative",
  },
  searchBar: {
    "&>input": {
      textOverflow: "ellipsis",
      paddingRight: "25px",
      backgroundColor: "white!important",
    },
    width: "400px",
  },
  searchIcon: {
    position: "absolute",
    width: "16px",
    right: "8px",
  },
  "@media (max-width: 1023px)": {
    searcharea: {
      margin: "0 9px 0px 9px",
    },
    searchBar: {
      width: "100%",
    },
  },
};
export default injectSheet(styles)(SearchArrangemangContainer);
